import React from 'react';
import { GlobalDesignActionPanel } from '../types';
import { AutomaticPanel } from '../../automaticPanel/AutomaticPanel';

const FillStyles: GlobalDesignActionPanel = (props) => {
  return <AutomaticPanel host={props.host} />;
};

export default FillStyles;
